module.exports = __webpack_public_path__ + "static/img/徽商银行@2x.df249ebd.png";